// The frames besides the owners' own (AppFrame) and the admin dashboard's: signed out, a bar with Sign in; and for one
// task (approving an MFD), a column with nothing beside it.
import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { ButtonLink } from '../ui';
import s from './Frames.module.css';

function Brand() {
  return (
    <Link to="/" className={s.brand} aria-label="TUNE Analytics">
      <img src="/logo.avif" alt="" width={38} height={21} />
      <span>TUNE Analytics</span>
    </Link>
  );
}

/** Signed out: TUNE's mark, Sign in and Make an account; the page; and Help at the foot. */
export function GuestFrame({ children }: { children: ReactNode }) {
  const { pathname, search } = useLocation();
  const here = `${pathname}${search}`;
  const next = here !== '/' ? `?${new URLSearchParams({ next: here })}` : '';
  return (
    <div className={s.guest}>
      <header className={s.guestBar}>
        <Brand />
        <div className={s.guestActions}>
          <ButtonLink to={`/sign-in${next}`} variant="plain">
            Sign in
          </ButtonLink>
          <ButtonLink to="/sign-up" size="small">
            Make an account
          </ButtonLink>
        </div>
      </header>
      <main id="main" tabIndex={-1} className={s.guestMain}>
        {children}
      </main>
      <footer className={s.guestFoot}>
        <Link to="/help">Help</Link>
        <Link to="/telemetry/sample">Try a sample session</Link>
      </footer>
    </div>
  );
}

/** One task, in a column: approving an MFD from the code it shows. */
export function FocusedFrame({ children }: { children: ReactNode }) {
  return (
    <div className={s.focused}>
      <header className={s.focusedBar}>
        <Brand />
        <Link to="/" className={s.close}>
          Close
        </Link>
      </header>
      <main id="main" tabIndex={-1} className={s.focusedMain}>
        {children}
      </main>
    </div>
  );
}
